module.exports = __webpack_public_path__ + "static/media/Wizz.d73ec344.png";